/* global jQuery Swiper initMap tgInit */

const ajaxurl = tca_local.ajax_url;
const asset_img_url = tca_local.asset_img_url; //gmap has dipendency
const plugin_path = tca_local.plugin_path; //gmap has dipendency

;(function($) {
	$(document).ready(function() {
		// runs for first page load
		init();
	})

	function init() {
		/**
		 * Run initialition for core functionality
		 */
		coreInit();

		/**
		 * run initialisation for external scripts
		 */
		//animationInit();
		//initMap();
		//gridSlider();

		//loadOverlay();
	}

	function coreInit() {
		// helps us detect touchscreen-based browsers
		window.isTouch = false
		$(window).one('touchstart', function onFirstTouch() {
			window.isTouch = true
			$('body').addClass('is-touch')
		})

		setScrollbar()

		/**
		 * General/global
		 */
		$('[input-select-all]').on('focus click', function() {
			setTimeout(() => {
				this.focus()
				this.setSelectionRange(0, 99999)
				this.select()
			}, 50)
		})

		/**
		 * navigation
		 */
		// mobile nav toggle
		$('#nav-toggle').click(function() {
			$('#site-navigation').toggleClass('toggled')
			$('#nav-toggle').toggleClass('toggled')
			$('body').toggleClass('is-no-scroll')
			$('#primary-menu .menu-item-has-children>a').removeClass('active').next().slideUp(200)
			$(this).attr(
				'aria-expanded',
				$(this).attr('aria-expanded') === 'false'
			)
		})
		// if mobile nav or if touchscreen, menu items with children can not be followed
		$('#primary-menu .menu-item-has-children>a').click(function(e) {
			if ($(window).width() < 996 || window.isTouch) {
				e.preventDefault()
				e.stopPropagation()
			}
		})
		// mobile menu sub-menu handling
		$('#primary-menu .menu-item-has-children>a').click(function(e) {
			if ($('#site-navigation').hasClass('toggled')) {
				console.log($(this).html());
				e.preventDefault()
				let dir = $(this).parent().attr('aria-expanded') === 'true'
				if (dir) {
					$(this).next().slideUp(200)
					$(this).parent().attr('aria-expanded', 'false')
				} else {
					$(this).next().slideDown(200)
					$(this).parent().attr('aria-expanded', 'true')
				}
			}
		})
		// when mobile menu open a click to anything else closes it
		$(document).click(function(event) {
			if (!$(event.target).closest('#site-navigation .site-mask, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				$('#site-navigation').removeClass('toggled')
				$('#nav-toggle').removeClass('toggled')
				$('body').removeClass('is-no-scroll')
			}
		})
		// mobile home nav background
		if ($('body').hasClass('home')) {
			navBg()
			$(document).on('scroll.headerbg', throttle(function() {
				navBg()
			}, 50))
			$(document).on('resize.headerbg', throttle(function() {
				navBg()
			}, 50))
		}
		function navBg() {
			if ($(window).width() < 996) {
				let opacity = $(window).scrollTop() / 400
				$('#header .header-bg').css('opacity', opacity > 0.85 ? 0.85 : opacity)
			} else {
				$('#header .header-bg').css('opacity', '')
			}
		}

		/**
		 * page head — carousel
		 */
		if ($('.v-pageHead__slide', '.v-pageHead__slider').length > 1) {
			new Swiper('.v-pageHead__slider', {
				autoplay: {
					delay: 7000
				},
				loop: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					bulletElement: 'button',
					clickable: true
				}
			})
		}

		/**
		 * testimonials
		 */
		new Swiper('.v-testimonials .swiper-container', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 10,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			  }
		})

		/**
		 * gallery section
		 */
		let galleryInit = false
		gallerySlider()
		function gallerySlider() {
			if (window.innerWidth < 992 && !galleryInit) {
				new Swiper('.v-gallery .swiper-container', {
					slidesPerView: 1,
					breakpoints: {
						768: {
							slidesPerView: 2
						}
					}
				})
				galleryInit = true
			} else if (window.innerWidth >= 992 && galleryInit) {
				$('.v-gallery .swiper-container').each(function() {
					$(this)[0].swiper.destroy()
				})
				galleryInit = false
			}
		}
		$(window).on('resize.gallerySlider', throttle(function() {
			gallerySlider()
		}, 50))

		/**
		 * logo slider
		 */
		new Swiper('.v-logos--slider--normal .v-logos__slider', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				540: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				996: {
					slidesPerView: 5
				}
			}
		})
		new Swiper('.v-logos--slider--large .v-logos__slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		})

		/**
		 * news slider
		 */
		new Swiper('.v-news__slider', {
			autoplay: {
				delay: 4000
			},
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1199: {
					slidesPerView: 3
				},
				1399: {
					slidesPerView: 4
				}
			}
		})

		/**
		 * advanced content image slider
		 */
		new Swiper('.v-content__advanced-item--image_slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				996: {
					slidesPerView: 3
				}
			}
		})


		/**
		 * skip link
		 */
		$('.skip-link').click(function(event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function() {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});

		/**
		 * advanced focus handling
		 */
		$('.v-panels__button').click(function() {
			$(this).next().focus()
		})

	}


	// set scrollbar
	function setScrollbar() {
		var body = document.querySelector('body')
		if (window.innerWidth > body.clientWidth + 5) {
			$('body').removeClass('no-scrollbar')
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				window.innerWidth - body.clientWidth + 'px'
			)
		} else {
			$('body').addClass('no-scrollbar')
		}
	}

	// Returns a function, that, when invoked, will only be triggered at most once
	// during a given window of time. Normally, the throttled function will run
	// as much as it can, without ever going more than once per `wait` duration;
	// but if you'd like to disable the execution on the leading edge, pass
	// `{leading: false}`. To disable execution on the trailing edge, ditto.
	function throttle(func, wait, options) {
		var context, args, result
		var timeout = null
		var previous = 0
		if (!options) options = {}
		var later = function() {
			previous = options.leading === false ? 0 : Date.now()
			timeout = null
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		return function() {
			var now = Date.now()
			if (!previous && options.leading === false) previous = now
			var remaining = wait - (now - previous)
			context = this
			args = arguments
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				previous = now
				result = func.apply(context, args)
				if (!timeout) context = args = null
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining)
			}
			return result
		}
	}


	/** SMTA Web js start here */

	$('#careerModal').on('show.bs.modal', function (event) {
		var card = $(event.relatedTarget);
		var description = card.find('#details #description').text();
		var duties_list = '<p>Duties and Responsibilities</p>' + card.find('#details #duties_list').html();
		var button_text = card.find('#details #button_text').text();
		var button_link = card.find('#details #button_link').text();
		var info = card.find('.overlay .info').html();
		var title = card.find('.overlay h3').text();

		var modal = $(this);
		modal.find('.modal-title').text(title);
		modal.find('.modal-body .info').html(info);
		modal.find('.modal-body .description').text(description);
		modal.find('.modal-body .duties_list').html(duties_list);
		modal.find('.modal-footer #link').text(button_text);
		modal.find('.modal-footer #link').attr('href', button_link);
	});

	$(document).ready(function(){


	});




})(jQuery);
